/**
 * Navigation-Asset v2: Valves Bot-Navmesh als Area-Graph.
 *
 * x/y aller Punkte liegen im Radar-Raster (0..1000) wie die Routenpunkte,
 * z in Welt-HU. `huPerRadarUnit` rechnet horizontale Strecken in HU um –
 * die Laufzeit braucht damit keine Kartentransformation.
 */
export const NAVIGATION_FORMAT_VERSION = 2;
export const navigationLinkKinds = [
    "walk",
    "jump",
    "crouch-jump",
    "run-jump",
    "drop",
    "ladder",
];
export function isNavigationAsset(value) {
    return (typeof value === "object" &&
        value !== null &&
        value.formatVersion ===
            NAVIGATION_FORMAT_VERSION &&
        Array.isArray(value.areas));
}
export function areaCornerCount(area) {
    return area.corners.length / 3;
}
